// @ts-nocheck
import {
  styled,
  TableCell,
  tableCellClasses,
  Tooltip
} from "@mui/material";

export const StyledTableCell = styled(TableCell)(({ theme, customError }) => ({
  [`&.${tableCellClasses.body}`]: {
    padding: "0.25rem",
    color: theme.palette.common.white,
    // paddingLeft: "1rem",
    textAlign: "center",
    cursor: "pointer",
    backgroundColor: customError ? "#7f4c4cd9" : "inherit",
    // borderColor: customError ? "#FF6B6B" : "inherit", // Light red border if error exists
    // borderWidth: customError ? "1px" : "initial",
    // borderStyle: customError ? "solid" : "inherit",
    position: "relative",
  },
}));

export const TableCellWithError = ({ children, customError, ...props }) => (
  <Tooltip
    title={customError || ""}
    placement="top"
    disableHoverListener={!customError}
  >
    <StyledTableCell customError={customError} {...props}>
      {children}
    </StyledTableCell>
  </Tooltip>
);